module.exports = __webpack_public_path__ + "static/media/CoworkSmall1Web.50c9eeab.webp";